enum ConfirmedEstimatedDateOfDeliveryBy {
    Ultrasound = 0,
    InVitroFertilization = 1
}

export { ConfirmedEstimatedDateOfDeliveryBy };
